import { WireObject } from 'content-creation-common/models';
import { isNil } from '../../util/object';

export default class UserContext extends WireObject {
  _adAccountId = null;
  _editionId = null;
  _organizationId = null;
  _publisherId = null;
  _businessProfileId = null;

  /**
   * @param {String|null} organizationId
   * @param {String|null} adAccountId
   * @param {String|null} publisherId
   * @param {String|null} businessProfileId
   * @param {String|null} editionId
   */
  constructor(
    organizationId = null,
    adAccountId = null,
    publisherId = null,
    businessProfileId = null,
    editionId = null,
  ) {
    super();

    this._adAccountId = adAccountId;
    this._editionId = editionId;
    this._organizationId = organizationId;
    this._publisherId = publisherId;
    this._businessProfileId = businessProfileId;
  }

  /**
   * Creates a copy of UserContext
   * @returns {UserContext}
   */
  copy() {
    return new UserContext(
      this.organizationId,
      this.adAccountId,
      this.publisherId,
      this.businessProfileId,
      this.editionId,
    );
  }

  toJSON() {
    return {
      ad_account_id: this.adAccountId,
      business_profile_id: this.businessProfileId,
      edition_id: this.editionId,
      organization_id: this.organizationId,
      publisher_id: this.publisherId,
    };
  }

  get organizationId() {
    return this._organizationId;
  }

  set organizationId(value) {
    this._organizationId = value;
  }

  get adAccountId() {
    return this._adAccountId;
  }

  set adAccountId(value) {
    this._adAccountId = value;
  }

  get businessProfileId() {
    return this._businessProfileId;
  }

  set businessProfileId(value) {
    this._businessProfileId = value;
  }

  get publisherId() {
    return this._publisherId;
  }

  set publisherId(value) {
    this._publisherId = value;
  }

  get editionId() {
    return this._editionId;
  }

  set editionId(value) {
    this._editionId = value;
  }

  /**
   * Determines if objects is an instance of UserContext
   * @param inUserContext
   * @returns {boolean}
   */
  static isUserContext(inUserContext) {
    return inUserContext instanceof UserContext;
  }

  static fromJSON(inJSON) {
    if (isNil(inJSON)) {
      throw new Error('UserContext.fromJSON inJSON is nil');
    }

    const {
      ad_account_id: adAccountId,
      business_profile_id: businessProfileId,
      edition_id: editionId,
      organization_id: organizationId,
      publisher_id: publisherId,
    } = inJSON;

    return new UserContext(organizationId, adAccountId, publisherId, businessProfileId, editionId);
  }
}
